// extracted by mini-css-extract-plugin
export default {"landingPageOptionList":"LandingPageOptionList_landingPageOptionList__w+yQE"};